import {
  SEARCH_USERS_LIST_PAGE_SUCCESS,
  SEARCH_USERS_LIST_PAGE_FAIL,
  SEARCH_USERS_LIST_PAGE_START,
  USERS_LIST_PAGE_DELETE_USERS_SUCCESS,
  USERS_LIST_PAGE_SET_LOADING,
  USERS_LIST_PAGE_EXPORT_USERS_START,
  USERS_LIST_PAGE_EXPORT_USERS_SUCCESS,
  USERS_LIST_PAGE_EXPORT_USERS_FAIL,
  USERS_LIST_PAGE_EXPORT_USERS_FINISHED,
  USERS_LIST_PAGE_UPDATE_SEARCH_PARAMS,
  USERS_LIST_PAGE_SEARCH_FILTER_ITEMS,
  USERS_LIST_PAGE_SEARCH_FILTER_ITEMS_START,
  USERS_LIST_PAGE_SEARCH_FILTER_ITEMS_SUCCESS,
  USERS_LIST_PAGE_SEARCH_FILTER_ITEMS_FAIL,
  USERS_LIST_PAGE_SET_ACTIVE_DYNAMIC_FILTERS,
  USERS_LIST_PAGE_RESET_DYNAMIC_FILTERS,
  USERS_LIST_PAGE_HYDRATE_ACTIVE_DYNAMIC_FILTERS,
} from 'actions/userList';

import {
  getListPageSuccessNewData,
  getListPageSuccessNewLinks,
} from '../utils';

export const defaultState = {
  loading: true,
  data: [],
  links: {},
  dataLoaded: false,
  paging: false,
  error: false,
  usersAdded: 0,
  exporting: false,
  latestSearchTimeStamp: 0,
  userDefinedFilterValues: {},
  groups: {
    activeItems: [],
    count: 0,
    data: [],
    loading: false,
    total: 0,
  },
  sites: {
    activeItems: [],
    count: 0,
    data: [],
    loading: false,
    total: 0,
  },
  filteredList: [],
};

export default function userListPage(state = defaultState, action) {
  switch (action.type) {
    case SEARCH_USERS_LIST_PAGE_START: {
      // COR-30224: Prevent race condition displaying wrong list info
      // For each search, overwrite the 'latestSearchTimeStamp' value in Redux.
      // That way, when we come to set the returned data, if the timestamps don't
      // match we know we're dealing with an old request and we shouldn't add
      // that data to the store.
      const { timeStamp } = action.payload;

      return {
        ...state,
        latestSearchTimeStamp: timeStamp,
        dataLoaded: false,
      };
    }
    case SEARCH_USERS_LIST_PAGE_SUCCESS: {
      const { data, links, total, timeStamp } = action.payload;

      const isLastestSearchResponse = timeStamp === state.latestSearchTimeStamp;

      return {
        ...state,
        ...(isLastestSearchResponse && {
          data: getListPageSuccessNewData(state, data, links),
          links: getListPageSuccessNewLinks(links),
          total,
          dataLoaded: true,
          loading: false,
          error: false,
          filteredList: [...data],
        }),
      };
    }
    case USERS_LIST_PAGE_SET_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case SEARCH_USERS_LIST_PAGE_FAIL: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }
    case USERS_LIST_PAGE_DELETE_USERS_SUCCESS: {
      return {
        ...state,
        data: [], // Require reload
      };
    }
    case USERS_LIST_PAGE_EXPORT_USERS_START: {
      return {
        ...state,
        exporting: true,
      };
    }
    case USERS_LIST_PAGE_EXPORT_USERS_FAIL: {
      return {
        ...state,
        exporting: false,
      };
    }
    case USERS_LIST_PAGE_EXPORT_USERS_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        loading: false,
        error: false,
        data,
      };
    }
    case USERS_LIST_PAGE_EXPORT_USERS_FINISHED: {
      return {
        ...state,
        exporting: false,
      };
    }
    case USERS_LIST_PAGE_UPDATE_SEARCH_PARAMS: {
      const { payload } = action;
      return {
        ...state,
        userDefinedFilterValues: {
          ...state.userDefinedFilterValues,
          ...payload,
        },
      };
    }

    case USERS_LIST_PAGE_HYDRATE_ACTIVE_DYNAMIC_FILTERS: {
      const [storeKey] = Object.keys(action.payload);
      const value = action.payload[storeKey];
      const count = value.length;

      return {
        ...state,
        [storeKey]: {
          data: [...value],
          count,
          total: count,
          loading: false,
        },
      };
    }

    case USERS_LIST_PAGE_SEARCH_FILTER_ITEMS: {
      return state;
    }
    case USERS_LIST_PAGE_SEARCH_FILTER_ITEMS_START: {
      const { endpoint: storeKey } = action.payload;
      return {
        ...state,
        [storeKey]: {
          ...state[storeKey],
          loading: true,
        },
      };
    }
    case USERS_LIST_PAGE_SEARCH_FILTER_ITEMS_SUCCESS: {
      const { count, data, total, endpoint: storeKey } = action.payload;

      return {
        ...state,
        [storeKey]: {
          ...state[storeKey],
          count,
          data,
          loading: false,
          total,
        },
      };
    }
    case USERS_LIST_PAGE_SEARCH_FILTER_ITEMS_FAIL: {
      return {
        ...state,
        groups: {
          ...state.groups,
          loading: false,
        },
        sites: {
          ...state.sites,
          loading: false,
        },
      };
    }
    case USERS_LIST_PAGE_SET_ACTIVE_DYNAMIC_FILTERS: {
      const { key, items } = action.payload;

      const activeItems = [
        ...state[key].activeItems,
        ...items.filter(
          item => !state[key].activeItems.find(a => a.id === item.id),
        ),
      ];

      return {
        ...state,
        [key]: {
          ...state[key],
          activeItems,
        },
      };
    }
    case USERS_LIST_PAGE_RESET_DYNAMIC_FILTERS: {
      const { key, items } = action.payload;
      return {
        ...state,
        [key]: {
          ...state[key],
          data: [],
          activeItems: items,
        },
      };
    }
    default:
      return state;
  }
}
